.geofenceRow {
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
	border-radius: 10px;

	.geofenceButton {
		display: flex;
		flex-direction: row;
		gap: 0.875rem;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		padding: 0.625rem 0.9375rem;
	}
}

.geofenceIconTitleWrapper {
	display: flex;
	flex-direction: row;
	gap: 0.875rem;
	align-items: center;
	width: 100%;
}

.geofenceTableContainer {
	width: 100%;
	min-width: 0;
}

.geofenceTableLocation {
	display: flex;
	align-items: center;
	gap: 0.875rem;
	min-width: 0;
}

.geofenceTableLocation .geofenceInfoWrapper {
	min-width: 0;

	& .name {
		color: #262626;
		font-weight: 400;
		font-size: 14px;
	}

	& .radius {
		color: #737373;
		font-weight: 400;
		font-size: 14px;
	}
}

.geofenceTableLocation .name {
	overflow-wrap: anywhere;
}

.geofenceTableIcon {
	display: inline-flex;
	flex: 0 0 34px;
	width: 34px;
	height: 34px;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	background: #f6f1ff;
	color: #5a35a0;
}

.geofenceTableIcon svg {
	width: 18px;
	height: 18px;
}

.geofenceTableAddButton:global(.MuiButton-root) {
	min-width: fit-content;
	white-space: nowrap;
}

.geofenceInfoWrapper {
	display: flex;
	flex-direction: column;
	gap: 0.125rem;
	width: 100%;
	align-items: flex-start;

	& .name {
		color: #212121;
		font-weight: 700;
		font-size: 0.9375rem;
		line-height: 1.6;
		letter-spacing: -0.08px;
	}

	& .radius {
		color: #9b9b9b;
		font-weight: 400;
		line-height: 1.6;
		font-size: 0.75rem;
	}
}

.addButton:global(.MuiButton-root) {
	height: 35px;
	min-width: fit-content;
	width: 161px;
}

.geofenceTitleContainer {
	justify-content: space-between;
	flex-direction: row;
}

.geofenceMenuButton {
	margin-right: 0.9375rem;
}

@media (max-width: 768px) {
	.geofenceTitleContainer {
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.geofenceRow {
		flex-direction: column;
		padding: 0.25rem;

		.geofenceButton {
			flex-direction: column-reverse;
		}
	}

	.geofenceIconTitleWrapper {
		flex-direction: column;
	}

	.geofenceInfoWrapper {
		align-items: center;
	}

	.geofenceMenuButton {
		margin-right: unset;
	}
}
